import { Select, Input } from 'antd'
import styled from 'styled-components'

export const WeatherSelect = styled(Select)`
  & > .ant-select-selector {
    border-top-left-radius: 0.625rem !important;
    border-bottom-left-radius: 0.625rem !important;
  }
`

export const WeatherInput = styled(Input)`
  width: 90px;

  & input[type='number'] {
    padding-right: 0;
  }
`
